// src/services/database.service.js

import axios from "axios";
import EventBus from "../common/EventBus";


const API_POSTGREST_URL = "https://www.smartelec.eu.org/ota_api_v2/";

const getDevices = async () => {
  // TODO : add bearer from localStorage

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url
  if ((localStorage.getItem("role") === 'admin_smart') || (localStorage.getItem("role") === 'partner'))
    url = `${API_POSTGREST_URL}devices?select=id,date_flash,date_reflash,date_update,version,type_str,type_id,mac_factory,mac_custom,user_id,comment,ble_name,version_app,date_app_cnx,manager_email,ack_errors_before,msg_devices_push(mac_custom, msg, date_viewed, date_push, fw_version_min, fw_version_max, id_msg, criticity)`;
  else
    url = `${API_POSTGREST_URL}devices_view_finaluser`;

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const getDevicesWithTags = async () => {
  // TODO : add bearer from localStorage

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url
  if ((localStorage.getItem("role") === 'admin_smart') || (localStorage.getItem("role") === 'partner'))
    url = `${API_POSTGREST_URL}devices?select=id,user_id,comment,ble_name,tag_keys&tag_keys=not.is.null`;
  else
    url = `${API_POSTGREST_URL}devices_view_finaluser`;

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const getFirmwares = async () => {
  // TODO : add bearer from localStorage

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_POSTGREST_URL}firmwares`;

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};


const getLogsDevice = async (mac_custom) => {

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_POSTGREST_URL}logs?mac_custom=ilike.` + mac_custom + "&order=date.desc";

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};




const getSettingsDescription = async (version) => {

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_POSTGREST_URL}settings_descriptions?version=eq.` + version;

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};


const getPerfsRun = async () => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_POSTGREST_URL}perfs_run_view_ble_name?order=timestamp.desc`;

  return axios.get(url, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const editPerfsRunComment = async (id, comment) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'  // Make sure the server knows we're sending JSON
  };

  // Use PostgREST filtering to specify which row to update
  const url = `${API_POSTGREST_URL}perfs_run?id=eq.${id}`;

  // Send the updated comment in the request body
  const data = {
    comment: comment
  };

  return axios.patch(url, data, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};



const editDeviceComment = async (id, comment) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'  // Make sure the server knows we're sending JSON
  };

  // Use PostgREST filtering to specify which row to update
  const url = `${API_POSTGREST_URL}devices?id=eq.${id}`;

  // Send the updated comment in the request body
  const data = {
    comment: comment
  };

  return axios.patch(url, data, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const lockPerfsRun = async (id, lock) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'  // Make sure the server knows we're sending JSON
  };

  // Use PostgREST filtering to specify which row to update
  const url = `${API_POSTGREST_URL}perfs_run?id=eq.${id}`;

  // Send the updated comment in the request body
  const data = {
    lock: lock
  };

  return axios.patch(url, data, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};




const editPerfsRunLaps = async (id, selectedCircuitID, markers) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'  // Make sure the server knows we're sending JSON
  };

  // Use PostgREST filtering to specify which row to update
  const url = `${API_POSTGREST_URL}perfs_run?id=eq.${id}`;

  // Construct the payload
  const data = {
    laps: markers
  };

  if (selectedCircuitID >= 0) {
    data.circuitId = selectedCircuitID;
  }

  return axios.patch(url, data, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const getPerfsData = async (timestamp) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_POSTGREST_URL}perfs_data?timestampRun=eq.` + timestamp + "&order=date.asc";
  // console.log("DatabaseService.getPerfsData / getPerfsData / url", url)

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const getPerfsRaceDevices = async () => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_POSTGREST_URL}devices_team_view`

  return axios.get(url, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};


const getPerfsRealtime = async (deviceIdList) => {
  // console.log("getPerfsRealtime / deviceIdList", deviceIdList)
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const deviceIds = deviceIdList.map(item => item.mac_custom);
  const url = `${API_POSTGREST_URL}perfs_realtime?mac_custom=in.(${deviceIds.join(",")})&order=mac_custom.asc`;

  return axios.get(url, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};


const changePassword = async (password) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`
  };
  console.log("auth.service / changePassword");

  return axios.post(API_POSTGREST_URL + "rpc/change_password", { "new_password": password }, { headers }).then((response) => {
    return response;
  });
};

const changeRaceUsername = async (username) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`
  };
  console.log("auth.service / changeRaceUsername");

  return axios.post(API_POSTGREST_URL + "rpc/change_race_username", { "new_race_username": username }, { headers }).then((response) => {
    return response;
  });
};



const deleteAccount = async () => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`
  };
  console.log("auth.service / deleteAccount");

  return axios.post(API_POSTGREST_URL + "rpc/delete_user", "", { headers }).then((response) => {
    return response;
  });
};


const removeUserDevice = async (mac_custom, owner_email) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url = API_POSTGREST_URL + "rpc/unregister_user_device"

  const data = {
    p_mac_custom: mac_custom,
    p_user_id: owner_email
  }

  return axios.post(url, data, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const removePerfsDatas = async (timestamp, deviceId) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url = API_POSTGREST_URL + "perfs_data?timestampRun=eq." + timestamp + "&device_id=eq." + deviceId
  // console.log(url)
  return axios.delete(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const removePerfsPartialDatas = async (timestamp, deviceId, beforeDate, afterDate) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  let url = API_POSTGREST_URL + "perfs_data?timestampRun=eq." + timestamp + "&device_id=eq." + deviceId
  if (beforeDate)
    url += "&date=lt." + beforeDate
  if (afterDate)
    url += "&date=gt." + afterDate

  // console.log(url)
  return axios.delete(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const removePerfsRun = async (timestamp, deviceId) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url = API_POSTGREST_URL + "perfs_run?timestamp=eq." + timestamp + "&device_id=eq." + deviceId
  console.log(url)
  return axios.delete(url, { headers }).catch((error) => {
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const removeLogs = async (mac_custom) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url = API_POSTGREST_URL + `logs?mac_custom=ilike.` + mac_custom
  console.log(url)
  return axios.delete(url, { headers }).catch((error) => {
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const getCircuitsList = async (showRejected = false) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url = `${API_POSTGREST_URL}circuits?select=id,name,country_code&order=name.asc`;

  if (!showRejected)
    url += `&status=neq.2`;

  return axios.get(url, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};


const getCircuits = async (showRejected = false) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url = `${API_POSTGREST_URL}circuits?order=name.asc`;

  if (!showRejected)
    url += `&status=neq.2`;

  return axios.get(url, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const getCircuitsGeojson = async (id) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${API_POSTGREST_URL}circuits?select=circuit_geojson,finish_geojson&id=eq.${id}`;


  return axios.get(url, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const createCircuit = async (trackData) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
  const url = `${API_POSTGREST_URL}circuits`;

  return axios.post(url, trackData, { headers })
    .then((response) => {
      return response; // The created track data
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const editCircuit = async (id, trackData) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
  const url = `${API_POSTGREST_URL}circuits?id=eq.${id}`;


  return axios.patch(url, trackData, { headers })
    .then((response) => {
      return response; // The updated track data
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const editCircuitStatus = async (id, status) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
  const url = `${API_POSTGREST_URL}circuits?id=eq.${id}`;

  // Send the updated comment in the request body
  const data = {
    status: status,
  };

  return axios.patch(url, data, { headers })
    .then((response) => {
      return response; // The updated track data
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};


const getLogsErrors = async () => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  //   const url = `${API_POSTGERST_URL}logs?text=ilike.` + "%new error state%" + "&order=date.desc";
  const url = `${API_POSTGREST_URL}logs?or=(text.ilike.*%new error state%,text.ilike.*%rebootReason%)&order=date.desc`;

  // rebootReason

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const editAckErrorsBefore = async (id, timestamp) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'  // Ensure the server knows we're sending JSON
  };

  // Use PostgREST filtering to specify which row to update
  const url = `${API_POSTGREST_URL}devices?id=eq.${id}`;

  // Send the updated comment in the request body
  const data = {
    ack_errors_before: timestamp
  };

  try {
    const response = await axios.patch(url, data, { headers });
    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    } else {
      console.log("DatabaseService.editAckErrorsBefore / error", error);
    }
    return Promise.reject(error);
  }
};


const editDeviceSettingsPush = async (mac_custom, owner_email, settingsToSave, reason) => {
  console.log("backend.service / editDeviceSettingsPush", mac_custom, settingsToSave);

  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const url = `${API_POSTGREST_URL}settings_devices_push`;

  // Check if the record exists
  const existingRecord = await axios.get(`${url}?mac_custom=eq.${encodeURIComponent(mac_custom)}&status=eq.0`, { headers });

  const data = {
    mac_custom: mac_custom,
    settings_values: settingsToSave,
    owner_email: owner_email,
    editor_email: localStorage.getItem("user"),
    date_push: (Date.now() / 1000).toFixed(0),
    reason: reason,
    status: 0
  };

  if (existingRecord.data.length > 0) {
    // Record exists, update it
    return axios.patch(`${url}?mac_custom=eq.${encodeURIComponent(mac_custom)}&status=eq.0`, data, { headers })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        return Promise.reject(error);
      });
  } else {
    // Record doesn't exist, insert it
    return axios.post(url, data, { headers })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        return Promise.reject(error);
      });
  }
}

const getDeviceSettingsPush = async (mac_custom) => {
  console.log("backend.service / getDeviceSettingsPush", mac_custom);

  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'  // Make sure the server knows we're sending JSON
  };

  // Use PostgREST filtering to specify which row to update
  // const url = `${API_POSTGERST_URL}settings_devices_push?id=eq.${id}`;
  const url = `${API_POSTGREST_URL}settings_devices_push?mac_custom=ilike.` + mac_custom + "&status=eq.0&order=date_push.desc";

  return axios.get(url, { headers })
    .then((response) => {
      // Handle successful response
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
}


const createMsg = async (mac_custom, owner_email, msg, fwMin, fwMax, criticity) => {
  console.log("backend.service / createMsg", mac_custom, msg, fwMin, fwMax, criticity);

  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'Prefer': 'return=representation'
  };

  const url = `${API_POSTGREST_URL}msg_devices_push`;

  const data = {
    mac_custom: mac_custom,
    owner_email: owner_email,
    msg: msg,
    fw_version_min: fwMin,
    fw_version_max: fwMax,
    editor_email: localStorage.getItem("user"),
    date_push: (Date.now() / 1000).toFixed(0),
    criticity: criticity
  };

  // Creating a new message - Ensure no primary key is included in the data
  return axios.post(url, data, { headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};


const editMsg = async (id_msg, mac_custom, owner_email, msg, fwMin, fwMax, date_viewed, criticity) => {
  console.log("backend.service / editMsg", mac_custom, msg, fwMin, fwMax);

  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const url = `${API_POSTGREST_URL}msg_devices_push`;

  const data = {
    mac_custom: mac_custom,
    owner_email: owner_email,
    msg: msg,
    fw_version_min: fwMin,
    fw_version_max: fwMax,
    editor_email: localStorage.getItem("user"),
    date_viewed: date_viewed,
    criticity: criticity
  };

  return axios.patch(`${url}?id_msg=eq.${id_msg}`, data, { headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const removeMsg = async (id) => {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  // Construct the URL to delete the message by ID
  const url = `${API_POSTGREST_URL}msg_devices_push?id_msg=eq.${id}`;

  return axios.delete(url, { headers })
    .then((response) => {
      return response; // Return the response if the delete was successful
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout"); // Dispatch logout if the error is a 401 Unauthorized
      }
      return Promise.reject(error); // Reject the promise with the error
    });
};

const getThemes = async () => {
  console.log("backend.service / getThemes");

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url = `${API_POSTGREST_URL}themes?select=id,owner_email,name,date_edit,type,shared,deleted&deleted=eq.false`;

        /*
        "id": 84,
        "owner_email": "koxx33@gmail.com",
        "name": "degub img",
        "date_edit": 1733062800,
        "type": 0,
        "deleted": false,
        "shared": true
        */

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

const getThemeData = async (id) => {
  console.log("backend.service / getThemes");

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  let url = `${API_POSTGREST_URL}themes?id=eq.${id}&select=data`;

        /*
        "id": 84,
        "owner_email": "koxx33@gmail.com",
        "name": "degub img",
        "date_edit": 1733062800,
        "type": 0,
        "deleted": false,
        "shared": true
        */

  return axios.get(url, { headers }).catch((error) => {
    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    return Promise.reject(error);
  });
};

export const createTheme = async (owner_email, themeName, themeType, dataTheme, screenshotBase64) => {
  console.log("backend.service / createTheme", owner_email, themeName, themeType, dataTheme, screenshotBase64);

  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'Prefer': 'return=representation'
  };

  const url = `${API_POSTGREST_URL}/themes`;

  const themeTypeInt = Number(themeType);

  const data = {
    owner_email: owner_email,
    name: themeName,
    type: themeTypeInt,
    data: dataTheme,
    screenshot: screenshotBase64, // Base64 string
    date_edit: Math.floor(Date.now() / 1000), // Unix timestamp
  };

  // Creating a new theme
  return axios.post(url, data, { headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};


export const editTheme = async (id, themeName, themeType, dataTheme, screenshotBase64) => {
  console.log("backend.service / editTheme", id, themeName, themeType, dataTheme, screenshotBase64);

  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const url = `${API_POSTGREST_URL}/themes`;

  const themeTypeInt = Number(themeType);

  const data = {
    name: themeName,
    type: themeTypeInt,
    data: dataTheme,
    screenshot: screenshotBase64, // Base64 string
    date_edit: Math.floor(Date.now() / 1000), // Unix timestamp
  };

  return axios.patch(`${url}?id=eq.${id}`, data, { headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};


export const shareTheme = async (id, shared) => {
  console.log("backend.service / shareTheme", shared);

  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const url = `${API_POSTGREST_URL}/themes`;

  const data = {
    shared: shared,
  };

  return axios.patch(`${url}?id=eq.${id}`, data, { headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const removeTheme = async (id) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const url = `${API_POSTGREST_URL}/themes`;

  const data = {
    deleted: true
  };

  return axios.patch(`${url}?id=eq.${id}`, data, { headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      return Promise.reject(error);
    });
};

const DatabaseService = {
  getDevices,
  getDevicesWithTags,
  removeUserDevice,
  editDeviceComment,
  getFirmwares,
  getPerfsRun,
  editPerfsRunComment,
  getPerfsData,
  removePerfsRun,
  lockPerfsRun,
  editPerfsRunLaps,
  removePerfsDatas,
  removePerfsPartialDatas,
  changePassword,
  changeRaceUsername,
  deleteAccount,
  getSettingsDescription,
  getPerfsRaceDevices,
  getPerfsRealtime,
  getLogsDevice,
  getCircuits,
  getCircuitsList,
  getCircuitsGeojson,
  createCircuit,
  editCircuit,
  editCircuitStatus,
  getLogsErrors,
  removeLogs,
  editAckErrorsBefore,
  editDeviceSettingsPush,
  getDeviceSettingsPush,
  createMsg,
  editMsg,
  removeMsg,
  getThemes,
  getThemeData,
  createTheme,
  editTheme,
  removeTheme,
  shareTheme
}


export default DatabaseService;
